import Service from '../service';

type CreateCasePayload = {
  caseReason: string;
  description: string;
  origin: string;
  caseType: string;
};

class SalesforceService extends Service {
  constructor() {
    super(config.salesforceServiceUrl);
  }

  async createSalesforceCase(payload: CreateCasePayload) {
    const url = `create-case`;
    const response = await this.axios.post(url, payload);
    return response.data;
  }
}

export default new SalesforceService();
